// import { UpdateWorkflowComponent } from '../../src/services/componentService';
import { v4 as uuidv4 } from 'uuid';
import { getComponentLines } from "../../src/services/workFlowService";

// Add event listener to listen for messages from the parent window
function fetchComponentData(setNodeKey) {
    return new Promise((resolve, reject) => {
        const eventHandler = async (event) => {
            try {
                // Unique node 'KEY' Get from parent and set output json to appropriate Component               
                if (event.source === window.parent) {
                    if (event.data != null && event.data !== "" && event.data !== undefined) {
                        const incomingData = event.data;
                        setNodeKey(event.data.key);
                        //Get component Data from Diagram json
                        const data = await compDataLoad(incomingData);

                        //Call API to get component output Line using unique COMPONENT NAME
                        const componentLines = await loadComponentLine(event.data.componentId) || null;

                        let compFullData = { ...data, componentLines };
                        resolve(compFullData);
                        window.removeEventListener('message', eventHandler);
                    }
                }
                else {
                    console.log("Unable to load data from diagram");
                }
            } catch (error) {
                reject(error);
                window.removeEventListener('message', eventHandler);
            }
        };
        window.addEventListener('message', eventHandler);
    });
}

async function loadComponentLine(compName) {
    const response = await getComponentLines(compName);
    if (response?.status === 200) {
        return response?.data?.lineItems
    }
    else {
        console.log("API(getComponentLines) FAILED AND STATUS: ", response?.status);
        return null;
    }
}

function saveComponentToWorkFlow(componentStepKey, componentJson, componentLines) {
    //Gernerate Line Object for Diagram
    const objComponentLine = componentLines?.map((value, index) => ({
        key: uuidv4(),
        lineType: value,
        lineNextFlow: 0,
        lineNextFlowText: "",
        lineText: value.replace(/\s+/g, "")
    }));

    const componentData = {
        key: componentStepKey,
        configData: componentJson,
        configLines: objComponentLine || null
    };
    window.parent.postMessage(JSON.stringify(componentData), '*');
}

const compDataLoad = async (incomingData) => {
    try {
        let componentData = incomingData.data;

        if (typeof componentData === "string") {
            componentData = JSON.parse(incomingData.data);
        }
        //Once component open and made save then we will have 'configData' key has data
        if (componentData?.configData) {
            componentData = componentData?.configData;
        }
        if (componentData?.loadJson?.configData) {
            componentData = componentData?.loadJson?.configData;
        }
        return typeof componentData === 'object' && componentData !== "" ? componentData : null;
    } catch {
        return null;
    }
    //     /* Get component master config json. It does not need because we load componet in palette with the default json itself */
    //     componentData = await fetchComponentMasterData(event.data.componentId);     
};


// const getFormatedComponentJson = async (processData) => {
//     try {
//         var compData = processData;
//         //Component json Load from Diagram will have this 'loadJson?.configData'
//         if (processData?.loadJson?.configData) {
//             compData = processData?.loadJson?.configData;
//         }

//         return compData;
//         // //Component load from master directly will have strict component json only
//         // if (processData?.componentSteps) {
//         //     return compData = processData;
//         // }
//     } catch { return compData; }
// }

// const fetchComponentMasterData = async (componentCode) => {
//     var componentData = null;
//     try {
//         if (componentCode && componentCode !== null) {
//             const response = await UpdateWorkflowComponent(componentCode);
//             if (response.success && response.hasOwnProperty("component")) {
//                 const data = JSON.parse(response.component.config);
//                 if (data) {
//                     componentData = data;
//                 }
//             }
//         }
//     } catch (error) {
//         console.error('Error in fetchComponentMasterData:', error);
//     }
//     return componentData;
// };

// function isJsonString(str) {
//     try {
//         JSON.parse(str);
//         return true;
//     } catch (e) {
//         return false;
//     }
// }


export { fetchComponentData, loadComponentLine, saveComponentToWorkFlow };